import { Api } from "../../common/lib/httpRequest";
import {
  GetEkycOptionsResponse,
  CreateEkycRequest,
  CreateEkycResponse,
  GetStockCodeOptionsResponse
} from "../utils/types";

export const apiGetEkycOptions = (params: any): Promise<GetEkycOptionsResponse> => {
  return Api.get(`api/v1/user/account/ekyc-options`, params);
};

export const apiCreateEkyc = (data: CreateEkycRequest): Promise<CreateEkycResponse> => {
  return Api.post(`api/v1/user/account/ekyc`, data);
};

export const apiGetStockCodeOptions = (params: any): Promise<GetStockCodeOptionsResponse> => {
  return Api.get(`api/v1/stockpick/stock-codes`, params);
};
